import {
  DeliveryOptionsItemInput,
  EnrichedSupplierForDelivery,
} from "../types";

type OrderItemInput = {
  partId: string;
  rootPartNumber: string;
  partNumber: string;
  orderedQuantity: number;
  partName: string;
  mrp?: number;
};

type SupplierPartInput = {
  rootPartNumber: string;
  allocatedQuantity: number;
};

/**
 * Builds delivery items payload by mapping supplier parts to order items.
 * Caller is responsible for quantity clamping logic.
 */
export const buildPartsPayloadForDeliveryOptions = (
  supplierParts: SupplierPartInput[],
  orderItems: OrderItemInput[] = []
): DeliveryOptionsItemInput[] => {
  const orderItemMap = new Map<string, OrderItemInput>();
  orderItems.forEach((item) => {
    const key = item.rootPartNumber;
    if (key) orderItemMap.set(key, item);
  });

  return supplierParts
    .map((part) => {
      const key = part.rootPartNumber;
      const orderItem = key ? orderItemMap.get(key) : undefined;
      const partNumber = orderItem?.partNumber;
      if (!partNumber) return null;

      return {
        partId: orderItem?.partId,
        partNumber,
        quantity: part.allocatedQuantity,
        partName: orderItem?.partName ?? "",
        mrp: orderItem?.mrp,
      } as DeliveryOptionsItemInput;
    })
    .filter(Boolean) as DeliveryOptionsItemInput[];
};

export const calculateSupplierFulfillingItemsMRP = (
  supplier: EnrichedSupplierForDelivery
): number => {
  if (!supplier.parts || supplier.parts.length === 0) {
    return 0;
  }

  let totalMRP = 0;
  let hasValidMRP = false;

  for (const part of supplier.parts) {
    if (part.mrp && part.mrp > 0 && part.quantity > 0) {
      totalMRP += part.mrp * part.quantity;
      hasValidMRP = true;
    }
  }

  return hasValidMRP ? totalMRP : 0;
};

export const calculateRemainingItemsMRP = (
  suppliers: EnrichedSupplierForDelivery[]
): number => {
  if (!suppliers || suppliers.length === 0) {
    return 0;
  }

  const remainingSupplier = suppliers.find(
    (supplier) =>
      supplier.supplierId === null || supplier.supplierId === undefined
  );

  if (!remainingSupplier) {
    return 0;
  }

  return calculateSupplierFulfillingItemsMRP(remainingSupplier);
};
